import { render, staticRenderFns } from "./vipCardStatus.vue?vue&type=template&id=1a5d23c6&scoped=true&"
import script from "./vipCardStatus.vue?vue&type=script&lang=js&"
export * from "./vipCardStatus.vue?vue&type=script&lang=js&"
import style0 from "./vipCardStatus.vue?vue&type=style&index=0&id=1a5d23c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d23c6",
  null
  
)

export default component.exports